"use client";

import { useAuth } from "../../../app/_components/providers/auth-provider";
import { useQueryParam } from "@src/hooks/utils/useQueryParam";

/**
 * Centralized hook for determining if AudioEngine DevTools should be shown.
 *
 * DevTools are shown when:
 * - User is a superuser, OR
 * - Running in development mode, OR
 * - Secret query param `?dt=true` is present
 */
export function useShowDevTools(): boolean {
  const { isSuperuser } = useAuth();
  const dtParam = useQueryParam<string>("dt", "");

  return isSuperuser || process.env.NODE_ENV === "development" || dtParam === "true";
}
